import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Home_context } from '../../context/home_context';

// let dummy_data=[
//     {
//         '%':'27.200000',
//         'EU INCI name':'Squalane',
//         'CAS Number':'111-01-3',
//         'EINECS number':'203-825-6',
//     },
//      {
//         '%':'24.000000',
//         'EU INCI name':'Triticum Vulgare Germ Oil',
//         'CAS Number':'68917-73-7',
//         'EINECS number':'-',
//     } ,
//     {
//         '%':'24.000000',
//         'EU INCI name':'Helianthus Annuus Seed Oil',
//         'CAS Number':'8001-21-6',
//         'EINECS number':'232-273-9',
//     },
//      {
//         '%':'24.000000',
//         'EU INCI name':'Hordeum Distichon Extract',
//         'CAS Number':'94349-67-4',
//         'EINECS number':'305-187-5',
//     } ,
//     {
//         '%':'0.800000',
//         'EU INCI name':'Phenoxyethanol',
//         'CAS Number':'122-99-6',
//         'EINECS number':'204-589-7',
//     }
// ]
export default function Regulations_table_one() {
  const { report_data_state } = useContext(Home_context);
  return (
    <div className=" report_id_tables card">
      <DataTable
        value={[{ ...report_data_state?.report_data }]}
        showGridlines
        className="page_table_font_size"
      >
        {/* <Column field="%" header="%"></Column> */}
        <Column field="rm_name_en" header="INCI name"></Column>
        <Column field="cas_number" header="CAS Number"></Column>
        <Column field="ec_number" header="EC Number"></Column>
      </DataTable>
    </div>
  );
}
